import { isMobileDevice } from 'helpers/environment';

export const isShareApiAvailable = () =>
  isMobileDevice() && Boolean(navigator.share) && Boolean(navigator.canShare);
